import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { AppContext } from 'constants/contexts';

import styles from './geospatial-item.less';
import GeospatialLegends from './geospatial-legends';
import MapItem from './map-item';

class GeospatialItem extends PureComponent {
  static propTypes = {
    data: PropTypes.shape({
      documents: PropTypes.array,
      metadata: PropTypes.object,
    }).isRequired,
    spec: PropTypes.object.isRequired,
    isResizing: PropTypes.bool,
    className: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
  };

  static defaultProps = {
    isResizing: false,
  };

  render() {
    const { spec, data, isResizing, width, height } = this.props;

    const _className = classnames(styles.root, this.props.className);

    return (
      <div className={_className} style={{ width, height }}>
        <AppContext.Consumer>
          {({ tileServer, tileAttributionMessage }) => (
            <MapItem
              {...this.props}
              isResizing={isResizing}
              width={width}
              height={height}
              tileServer={tileServer}
              tileAttributionMessage={tileAttributionMessage}
            />
          )}
        </AppContext.Consumer>
        <GeospatialLegends spec={spec} data={data} />
      </div>
    );
  }
}

export default GeospatialItem;
export { GeospatialItem };
